export class Subregion {

    constructor(readonly regionId: number, readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Subregion.ts